/**
 * FAQ accordion: opening one item closes the others in the same block.
 */
document.addEventListener('toggle', (event) => {
	const item = event.target;
	if (!(item instanceof HTMLDetailsElement) || !item.open || !item.classList.contains('faq__item')) {
		return;
	}

	const faq = item.closest('.faq');
	if (!faq) {
		return;
	}

	faq.querySelectorAll('details.faq__item[open]').forEach((other) => {
		if (other !== item) {
			other.open = false;
		}
	});
}, true);
